
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/producto/[prodSlug]",
      function () {
        return require("private-next-pages/producto/[prodSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/producto/[prodSlug]"])
      });
    }
  